<template>
    <v-menu 
        activator="parent" 
        open-on-hover offset-y 
        :close-on-content-click="true"
        location="top"
        :attach="isFullScreen ? '#view-toggle' : undefined">
        
        <v-list density="compact">
            <v-list-subheader>{{headerName}} </v-list-subheader>
            <v-list-item
                v-for="(item, i) in sortedAssets"
                :key="i"
                density="compact"
                class="ma-1"
                @click="modelUpdated(item)"
            >
                <div class="d-flex align-center">
                    <v-icon :color="selectedAsset._id === item._id ? 'green' : 'grey'" size="10">{{ icons.circle }}</v-icon>
                    <v-list-item-title>
                        <span v-if="item.drawingnumber">{{ item.drawingnumber }}|</span>
                        <span>{{ item.cleanName }}</span>
                    </v-list-item-title>
                </div>
            </v-list-item>

        </v-list>
    </v-menu>
</template>
<script>
import { storeToRefs } from 'pinia';
import { useNotebookPropsStore } from "@/store/NotebookPropsStore.js";
import * as icons from "@/utilities/EllipseIcons.js";

export default {
    props: ["assets", "selectedAsset", "isFullScreen"],
    data() {
        return {
            closeOnContentClick: false,
        };
    },
    setup() {
        const notebookPropsStore = useNotebookPropsStore()
        const {
            getEditMode,
        } = storeToRefs(notebookPropsStore)
        const {
        } = notebookPropsStore
        return { getEditMode, icons }
    },
    computed: {
        headerName(){
           return this.assets.length > 0 && this.assets[0].name.endsWith('.3dm') ? 'MODELS' : 'DRAWINGS';
        },
        sortedAssets() {
            return this.assets.slice().sort((a, b) => {
            // If both have drawingnumber, compare by drawingnumber
            if (a.drawingnumber && b.drawingnumber) {
                if (a.drawingnumber < b.drawingnumber) return -1;
                if (a.drawingnumber > b.drawingnumber) return 1;
                // If drawingnumber is equal, fall back to cleanName
                if (a.cleanName < b.cleanName) return -1;
                if (a.cleanName > b.cleanName) return 1;
                return 0;
            }
            // If only a has drawingnumber, it comes first
            if (a.drawingnumber && !b.drawingnumber) return -1;
            // If only b has drawingnumber, it comes first
            if (!a.drawingnumber && b.drawingnumber) return 1;
            // If neither has drawingnumber, compare by cleanName
            if (a.cleanName < b.cleanName) return -1;
            if (a.cleanName > b.cleanName) return 1;
            return 0;
            });
        },
    },
    methods: {
        modelUpdated(item) {
            this.$emit("modelUpdated", item);
        },
    },
};
</script>
<style scoped></style>